import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../_services/profile.services';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {



  constructor() { }

  ngOnInit() {
   
  }

}
